// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reachus-container {
  margin: 0;
  padding-top: 30px;
  font-family: Arial, sans-serif;
  background-color: #f7f7f7;
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  margin-top: 50px;
}

.content-section {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.map-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: auto;
}

.map-box iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.form-box {
  margin-top: 55px;
  position: relative;
  z-index: 2;
  background: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  width: 350px;
  max-width: 90%;
  margin-left: 70%;
  text-align: left;
}

.contact-form label {
  margin-top: 10px;
  font-size: 0.85em;
  font-weight: bold;
  color: #333;
}

.input-field,
.textarea-field {
  margin-top: 5px;
  width: 95%;
  padding: 10px;
  font-size: 0.9em;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.textarea-field {
  resize: none;
}

.send-button {
  width: 102%;
  height: 40px;
  font-size: 1em;
  background-color: #28a745;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}

.send-button:hover {
  background-color: #218838;
}

@media screen and (min-width: 1920px) {
  .reachus-container {
    padding-top: 50px;
  }
}
@media (max-width: 1366px) {
  .reachus-container {
    margin: 0;
    padding-top: 30px;
    font-family: Arial, sans-serif;
    background-color: #f7f7f7;
    position: relative;
    min-height: 100vh;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    margin-top: 50px;
  }

  .content-section {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }

  .map-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: auto;
  }

  .map-box iframe {
    width: 100%;
    height: 100%;
    border: none;
  }

  .form-box {
    margin-top: 55px;
    position: relative;
    z-index: 2;
    background: rgba(255, 255, 255, 0.9);
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    width: 350px;
    max-width: 90%;
    margin-left: 70%;
    text-align: left;
  }

  .contact-form label {
    margin-top: 10px;
    font-size: 0.85em;
    font-weight: bold;
    color: #333;
  }

  .input-field,
  .textarea-field {
    margin-top: 5px;
    width: 95%;
    padding: 10px;
    font-size: 0.9em;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .textarea-field {
    resize: none;
  }

  .send-button {
    width: 102%;
    height: 40px;
    font-size: 1em;
    background-color: #28a745;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
  }

  .send-button:hover {
    background-color: #218838;
  }

  @media (max-width: 768px) {
    .reachus-container {
      flex-direction: column;
      align-items: center;
      margin-top: 0px;
    }

    .map-box {
      pointer-events: auto;
      margin-top: 20px;
      height: 200px;
      width: 100%;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      margin-bottom: 20px;
    }

    .form-box {
      width: 80%;
      margin-top: -50px;
    }

    .form-box,
    .map-box {
      border-radius: 10px;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    }

    .form-box {
      margin-top: 240px;
      margin-left: 20px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ReachUs/ReachUs.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,SAAS;IACT,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;EACb;;EAEA;;IAEE,eAAe;IACf,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,sBAAsB;MACtB,mBAAmB;MACnB,eAAe;IACjB;;IAEA;MACE,oBAAoB;MACpB,gBAAgB;MAChB,aAAa;MACb,WAAW;MACX,2CAA2C;MAC3C,mBAAmB;MACnB,mBAAmB;IACrB;;IAEA;MACE,UAAU;MACV,iBAAiB;IACnB;;IAEA;;MAEE,mBAAmB;MACnB,2CAA2C;IAC7C;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF;AACF","sourcesContent":[".reachus-container {\n  margin: 0;\n  padding-top: 30px;\n  font-family: Arial, sans-serif;\n  background-color: #f7f7f7;\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  overflow: hidden;\n  margin-top: 50px;\n}\n\n.content-section {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.map-box {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: auto;\n}\n\n.map-box iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.form-box {\n  margin-top: 55px;\n  position: relative;\n  z-index: 2;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  width: 350px;\n  max-width: 90%;\n  margin-left: 70%;\n  text-align: left;\n}\n\n.contact-form label {\n  margin-top: 10px;\n  font-size: 0.85em;\n  font-weight: bold;\n  color: #333;\n}\n\n.input-field,\n.textarea-field {\n  margin-top: 5px;\n  width: 95%;\n  padding: 10px;\n  font-size: 0.9em;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.textarea-field {\n  resize: none;\n}\n\n.send-button {\n  width: 102%;\n  height: 40px;\n  font-size: 1em;\n  background-color: #28a745;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.send-button:hover {\n  background-color: #218838;\n}\n\n@media screen and (min-width: 1920px) {\n  .reachus-container {\n    padding-top: 50px;\n  }\n}\n@media (max-width: 1366px) {\n  .reachus-container {\n    margin: 0;\n    padding-top: 30px;\n    font-family: Arial, sans-serif;\n    background-color: #f7f7f7;\n    position: relative;\n    min-height: 100vh;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    overflow: hidden;\n    margin-top: 50px;\n  }\n\n  .content-section {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    overflow: hidden;\n  }\n\n  .map-box {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 0;\n    pointer-events: auto;\n  }\n\n  .map-box iframe {\n    width: 100%;\n    height: 100%;\n    border: none;\n  }\n\n  .form-box {\n    margin-top: 55px;\n    position: relative;\n    z-index: 2;\n    background: rgba(255, 255, 255, 0.9);\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    width: 350px;\n    max-width: 90%;\n    margin-left: 70%;\n    text-align: left;\n  }\n\n  .contact-form label {\n    margin-top: 10px;\n    font-size: 0.85em;\n    font-weight: bold;\n    color: #333;\n  }\n\n  .input-field,\n  .textarea-field {\n    margin-top: 5px;\n    width: 95%;\n    padding: 10px;\n    font-size: 0.9em;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n  }\n\n  .textarea-field {\n    resize: none;\n  }\n\n  .send-button {\n    width: 102%;\n    height: 40px;\n    font-size: 1em;\n    background-color: #28a745;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 10px;\n  }\n\n  .send-button:hover {\n    background-color: #218838;\n  }\n\n  @media (max-width: 768px) {\n    .reachus-container {\n      flex-direction: column;\n      align-items: center;\n      margin-top: 0px;\n    }\n\n    .map-box {\n      pointer-events: auto;\n      margin-top: 20px;\n      height: 200px;\n      width: 100%;\n      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n      border-radius: 10px;\n      margin-bottom: 20px;\n    }\n\n    .form-box {\n      width: 80%;\n      margin-top: -50px;\n    }\n\n    .form-box,\n    .map-box {\n      border-radius: 10px;\n      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    }\n\n    .form-box {\n      margin-top: 240px;\n      margin-left: 20px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
